import Event from '../const/event';
import { logMethodCall } from '../utils/debug';

export function initTagButtons(context) {
  logMethodCall('initTagButtons');

  context.tagButtons = context.tagButtons || [];

  const tagButtons = document.querySelectorAll('.cleverpush-tag-button');
  if (!tagButtons.length) {
    return;
  }
  import('./index').then(({ default: TagButton }) => {
    for (let i = 0; i < tagButtons.length; i += 1) {
      const element = tagButtons[i];
      const tagButton = new TagButton(i, element, context.config, context.subscriptionManager, context.api, context.triggerOptIn.bind(context));

      context.on(Event.SUBSCRIBED, () => {
        tagButton.reset(true);
      });
      context.on(Event.UNSUBSCRIBED, () => {
        tagButton.reset(false);
      });

      context.tagButtons.push(tagButton);
    }
  });
}
